<template>
  <div style="padding: 0px 8px;height: calc(100vh - 195px);overflow: auto"> 

    <div class="textTitle">{{$t('ACSetting.空调模式')}}</div>
    <div style="margin-top:10px">
      <el-button :size="size" :disabled="realLoading"
        :class="inModeBtn == item.value ? 'active' : 'inactive'" 
        v-for="item in modeBtns" 
        :key="item.value" 
        @click="modeClick(item.value)"
      >{{item.label}}</el-button>
    </div>

    <div class="textTitle">{{$t('ACSetting.空调温度')}}(℃)</div>
    <div class="tmp">
      <img src="@/assets/images/icon_wendu_jian.png" class="imgClick" @click="jian">
      <div class="slider">
        <div class="tempText" :style="{left:left}">{{temp}}<span>℃</span> </div>
        <el-slider v-model="temp" 
          :disabled="realLoading"
          :show-tooltip="false" 
          :min="17"
          :max="27"
          @input="sliderChangeInput"
          @change="sliderChange"
        ></el-slider>
      </div>
      <img src="@/assets/images/icon_wendu_jia.png" class="imgClick" @click="jia">
    </div>

    <div class="textTitle">{{$t('ACSetting.风速挡位')}}</div>
    <div  class="selectTime fanWidth">
        <el-select v-model="windSpeed" :size="size" @change="windSpeedChange()" :disabled="realLoading">
          <el-option
            v-for="item in windSpeedOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </div>

    <div class="textTitle">{{$t('ACSetting.预约类型')}}</div>
    <div style="margin-top:10px">
      <el-button :size="size" :disabled="realLoading"
        v-for="item in typeBtns" 
        :class="inTypeBtn == item.value ? 'active' : 'inactive'" 
        :key="item.value" 
        @click="typeClick(item.value)"
      >{{item.label}}</el-button>
    </div>
    <div>
      <div v-if="inTypeBtn == 1">
        <div style="width:520px;display:flex;">
          <div class="textTitle flex1">{{$t('ACSetting.预约周期时间')}}</div>
          <div class="textTitle flex1">{{$t('ACSetting.预约开启时间')}}</div>
        </div>
        <div style="width:520px;display:flex;margin-top:20px">
          <div class="flex1">
            <el-date-picker
              :size="size"
              v-model="dateRanDate"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              type="daterange"
              key="dateRanDate"
              range-separator="-"
              :picker-options="datePickerOptions"
              :clearable="false">
            </el-date-picker>
          </div>
          <div class="flex1">
            <el-time-picker
              :size="size"
              v-model="rangeTime"
              key="rangeTime"
              format="HH:mm"
              value-format="HH:mm"
              :clearable="false">
            </el-time-picker>
          </div>
        </div>
      </div>
    </div>

    <div v-if="this.inTypeBtn ==0">
      <div class="textTitle _durationShow">
        <div>{{ACState?$t('ACSetting.空调剩余时长'):$t('ACSetting.空调开启时长')}}</div>
        <div v-show="ACState">{{`${durationShow}(mm:ss)`}}</div>
      </div>
    </div>
    <div v-else>
      <div class="textTitle _durationShow">
        <div>{{haseBooking?$t('ACSetting.空调剩余时长'):$t('ACSetting.空调开启时长')}}</div>
      </div>
    </div>
    <div style="display: flex;width:520px;">
      
      <div  class="selectTime">
        <el-select v-model="duration[1]" :size="size" :disabled="minuteDisabled || realLoading" @change="minuteChange()">
          <el-option
            v-for="item in minute"
            :key="item.value"
            :label="item.label"
            :value="item.value"
            :disabled="item.disabled"
          >
          </el-option>
        </el-select>
      </div>
    </div>
    <!-- <div style="display: flex;width:520px;">
      <div  class="selectTime">
        <el-select v-model="duration[0]" placeholder="请选择" :size="size" @change="minuteChange()" :disabled="realLoading">
          <el-option
            v-for="item in hours"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div  class="selectTime">
        <el-select v-model="duration[1]" placeholder="请选择" :size="size" :disabled="minuteDisabled || realLoading" @change="minuteChange()">
          <el-option
            v-for="item in minute"
            :key="item.value"
            :label="item.label"
            :value="item.value"
            :disabled="item.disabled"
          >
          </el-option>
        </el-select>
      </div>
    </div> -->
    <div style="width:500px;text-align:right;margin-top:40px;">
      <!-- 立即执行的开启/关闭按钮 -->
      <div v-if="closeBtn">
        <el-button :size="size" type="primary"  @click="realControlAC()" :disabled="!configStatus" :loading="realLoading">{{closeBtnText}}</el-button>
        <!-- <el-button :size="size" type="primary" plain  @click="realControlAC(1)" v-if="ACState">修改</el-button> -->
      </div>
      <!-- 预约的保存按钮 -->
      <el-button :size="size" type="primary" @click="confirm(1)" v-if="!closeBtn&&haseBooking" :loading="bookLoading" :disabled="!configStatus">{{$t('ACSetting.关闭预约')}}</el-button>
      <el-button :size="size" type="primary" @click="confirm()" v-if="!closeBtn" :loading="bookLoading" :disabled="!configStatus">{{haseBooking?$t('ACSetting.修改预约'):$t('public.save')}}</el-button>
    </div>
  </div>
</template>
<script>
import { controlEncrypt} from '@/utils/encrypt';
import { mapState } from 'vuex';
export default {
  props:{
    tabs:{
      type:String,
      default:"first"
    }
  },
  data(){
    return{
      durationShow:"00:00",
      delayTimer: undefined,
      editUpdate: false,
      haseBooking:false,
      realLoading:false,
      bookLoading:false,
      ACState:false,//车辆空调开启状态
      minuteDisabled:false,
      windSpeed:1,
      windSpeedOptions:[],
      rangeTime:'',
      dateRanDate:[],
      duration:[0,10],//hours，minute
      hours:[],
      minute:[],
      modeBtns:[],
      inModeBtn: 1,
      temp:21,
      left:"0%",
      typeBtns:[],
      inTypeBtn: 0,
      datePickerOptions:{
        disabledDate(date) {
          return date < new Date(new Date().getTime() -  24 * 60 * 60 * 1000)
        }
      },
      vehicles:"",
      secondInterval:undefined,
      isShowReply:false,
      goOnOrOff: 'off',
      configStatus:true,
      isFirst:true,
    }
  },
  methods:{
    bookingAC(){
      //发生预约指令
      
    },
    minuteChange(){
      if(this.ACState){
        let allMinute = this.duration[0]*60+this.duration[1];
        this.realControlAC(1,{OperationDuration: allMinute+'',},);
      }
    },
    judge(){
      this.vehicles = this.getSelectedVehicles();
      if(this.vehicles == ""&&this.tabs == "first"){
        this.$message({
          message: this.$t('ACSetting.请先勾选左侧列表中的车辆'),
          type: "warning", 
        })
        return false;
      }
      if(this.vehicles.indexOf(',')>-1){
        this.$message({
          message: this.$t('vehicletrack.selectmorevehicle'),
          type: "warning", 
        })
        return false;
      }
      return true;
    },
    realControlAC(tag,editVal){
      
      // 空调实时控制
      if(this.inTypeBtn != 0) return;
      let confirmText = {};
      let isOr = this.judge();
      console.log(isOr);
      if(!isOr) return;
      this.realLoading = true;
      let allMinute = this.duration[0]*60+this.duration[1];

      if(this.closeBtnText == this.$t('public.open')){
          console.log("开启");
          this.goOnOrOff = "on";
          confirmText = {
            VehicleID: this.vehicles,
            cmdCode: "4",
            AppFlag: 2,//1：从APP，2：从web
            params:{
              ACMode: this.inModeBtn+'',
              TargetACTemp: this.temp+'',
              EvaporatorFan: this.windSpeed+'',
              OperationDuration: allMinute+'',
            }
          };
          
      }else{
        if(tag){
          // 修改
          console.log("修改");
          // console.log(tag,editVal);return;
          this.goOnOrOff = "on";
          this.editUpdate = true;
          confirmText = {
            VehicleID: this.vehicles,
            cmdCode: "4",
            AppFlag: 2,//1：从APP，2：从web
            params: editVal
          };
        }else{
          // 关闭
          this.goOnOrOff = "off";
          confirmText = {
            VehicleID: this.vehicles,
            cmdCode: "5",
            AppFlag: 2,//1：从APP，2：从web
          };
        }
      }
      const ciphertextPara = controlEncrypt(confirmText);
      // console.log(ciphertextPara);
      // console.log(confirmText);
      this.$api.realtimeControl(ciphertextPara)
      .then((res)=>{
        if(res.code == 200){
          this.isShowReply = true;
          this.realLoading = false;
          this.$message({
            message: this.$t('tree.下发成功'),
            type: "success", 
          })

          if(this.closeBtnText != this.$t('public.open')){
            if(tag){
              // 修改成功，5秒后在实时刷新状态
              this.editUpdate = true;
              this.delayTimer = setTimeout(() => {
                this.editUpdate = false;
              }, 5000)
            }else{
              // 关闭

            }
          }
        }
      })
      .catch((e)=>{
        this.realLoading = false;
      })
    },
    confirm(cancel){
      let isOr = this.judge();
      if(!isOr) return;
      let confirmText = {};
      let allMinute = this.duration[0]*60+this.duration[1];
      // 周期预约 remoteControlAC
      if(this.dateRanDate.length == 0 || this.rangeTime == "") {
        this.$message({
          message: this.$t('ACSetting.请选择预约日期及时间'),
          type: "warning", 
        })
        return;
      }
      if(cancel == 1){
        //发送关闭指令
        confirmText = {
          beginDate: "",
          endDate: "",
          time: "",
          duration: 0,
          temp: 0 ,
          VehicleID: this.vehicles,
          cancel: 1, // 0：正常 1：取消预约
          ACMode: "",
          EvaporatorFan: "",
          AppFlag: 2,//1：从APP，2：从web
        };
      }else{
        confirmText = {
          beginDate: this.dateRanDate[0],
          endDate: this.dateRanDate[1],
          time: this.rangeTime,
          duration: allMinute,
          temp: this.temp,
          VehicleID: this.vehicles,
          cancel: 0, // 0：正常 1：取消预约
          ACMode: this.inModeBtn,
          EvaporatorFan: this.windSpeed,
          AppFlag: 2,//1：从APP，2：从web
        };
      }
      const ciphertextPara = controlEncrypt(confirmText);
      console.log(ciphertextPara);
      console.log(confirmText);
      this.$api.remoteControlAC(ciphertextPara)
      .then((res)=>{
        if(res.code == 200){
          if(cancel == 1){
            // 关闭成功
            this.haseBooking = false;
          }else{
            let bookingStateItem = this.haseBooking;
            this.haseBooking = true;
            if(bookingStateItem){

              this.$message({
                message: this.$t('public.edit_success'),
                type: "success", 
              })
            }
          }
        }
      })
    },
    getSelectedVehicles(){
      this.vehicles = "";
      for(let k = 0; k < this.selectedVehicles.length; k++){
        if(this.selectedVehicles[k].treeLevel == 5){
          this.vehicles = this.vehicles + this.selectedVehicles[k].nodeValue + ",";
        }
      }
      return this.vehicles.substring(0,this.vehicles.length-1);
    },
    windSpeedChange(){
      // console.log(this.windSpeed);return;
      if(this.ACState){
        this.realControlAC(1,{EvaporatorFan: this.windSpeed+'',},);
      }
    },
    typeClick(val){

      if(val == 0 && this.inTypeBtn !=0 ){
        // 从另外两个按钮预约切换回立即，查下当下实时状态
        // this.queryReal();
        this.vehicles = this.getSelectedVehicles();
        let isOr = this.judge();
        if(!isOr) {
          this.ACState = false;
        }else{
          this.inModeBtn = 1;
          this.temp = 21;
          this.windSpeed = 1;
          this.duration[0] = 0;
          this.duration[1] = 30;
          this.startTimer();
        }
      }
      if(val != 0 && this.inTypeBtn == 0){
        // 从立即切换回预约，查询该车是否在预约范围中未失效
        this.queryBooking();
        this.stopTimer();
      }

      this.inTypeBtn = val;
      this.ACState = false;
    },
    sliderChangeInput(){
      // slider活动过程实时触发
      this.computeLeft();
    },
    sliderChange(flag){
      
      this.computeLeft();
      if(this.ACState){
        this.realControlAC(1,{TargetACTemp: this.temp+'',},);
      }

    },
    computeLeft(){
      this.left = ((this.temp - 17)/10*100)-4 + '%';
    },
    jian(){
      if(this.temp == 17) return;
      this.temp -= 1;
      this.computeLeft();
      if(this.ACState){
        this.realControlAC(1,{TargetACTemp: this.temp+'',},);
      }
    },
    jia(){
      if(this.temp == 27) return;
      this.temp += 1;
      this.computeLeft();
      if(this.ACState){
        this.realControlAC(1,{TargetACTemp: this.temp+'',},);
      }
    },
    modeClick(val){
      this.inModeBtn = val;
      if(this.ACState){
        this.realControlAC(1,{ACMode: this.inModeBtn+''},);
      }
    },
    queryBooking(){
      this.vehicles = this.getSelectedVehicles();
      let isOr = this.judge();
      if(!isOr) {
        this.ACState = false;
      }else{
        this.bookLoading = true;
        this.$api.queryRemoteControlACStatus({
          VehicleID: parseInt(this.vehicles)  ,//156918,//106309,// 156918,//this.VehicleID,
        })
        .then((res)=>{
          this.bookLoading = false;
          // res.beginDate = "2025-07-31";
          // res.endDate = "2025-07-31";
          // res.ACMode = "3";
          // res.temp = "22";
          // res.EvaporatorFan = "2";
          // res.time = "08:05";
          // res.ACRemainingTime = "22";
          if(res.beginDate != ""){
            this.haseBooking = true;

            this.inModeBtn = parseInt(res.ACMode);
            this.temp = parseInt(res.temp);
            this.windSpeed = parseInt(res.EvaporatorFan);
            this.dateRanDate = [res.beginDate,res.endDate];
            this.rangeTime = res.time;
            let _ACRemainingTime = parseInt(res.duration);
            this.duration[0] = Math.floor(_ACRemainingTime/60);
            this.duration[1] = _ACRemainingTime%60;
          }else{
            this.haseBooking = false;

            this.inModeBtn = 1;
            this.temp = 21;
            this.windSpeed = 1;
            // this.dateRanDate = [];
            // this.rangeTime = "";
            const now = new Date();
            now.setTime(now.getTime() + 5 * 60 * 1000);
            const hours = String(now.getHours()).padStart(2, '0');
            const minutes = String(now.getMinutes()).padStart(2, '0');
            const result = `${hours}:${minutes}`;

            this.rangeTime = result;
            this.dateRanDate = [now, now];
            this.duration[0] = 0;
            this.duration[1] = 10;
          }
        })

        // 查询空调有无配置
        this.$api.queryRealTimeVehicleInfo({
          VID: this.vehicles ,//156918,//106309,// 156918,//this.VehicleID,
        })
        .then((res)=>{
          let configValue =  parseInt(!res.RCStatus.ConfigStatus || res.RCStatus.ConfigStatus == "" ? "0" : res.RCStatus.ConfigStatus);
          // let configValue =  1022;
          this.configStatus = this.isBitSet(configValue, 8);//空调

          if(!this.configStatus){
            this.$message({
              message: this.$t("ACSetting.本车无此配置"),
              showClose: true,
            });
          }
        })
      }
    },
    isBitSet(num, n) {
      return (num & (1 << n)) !== 0;
    },
    async queryReal(){
      // this.vehicles = this.getSelectedVehicles();
      // let isOr = this.judge();
      // if(!isOr) {
      //   this.ACState = false;
      // }else{
        // 符合选一辆车条件，查该车当下空调状态
        
        await this.$api.queryRealTimeVehicleInfo({
          VID: this.vehicles ,//156918,//106309,// 156918,//this.VehicleID,
        })
        .then((res)=>{
          // this.ACState = true;
          this.ACState = res.RCStatus.ACSwitch == "1" ? true : false;
          if(this.isFirst){
            
            let configValue =  parseInt(!res.RCStatus.ConfigStatus || res.RCStatus.ConfigStatus == "" ? "0" : res.RCStatus.ConfigStatus);
            // let configValue =  1022;
            this.configStatus = this.isBitSet(configValue, 8);//空调

            this.isFirst = false;
            if(!this.configStatus){
              this.$message({
                message: this.$t("ACSetting.本车无此配置"),
                showClose: true,
              });
              
              this.stopTimer();
            }
          }
          if(this.ACState && !this.editUpdate){
          // if(res.RCStatus.ACSwitch == "1"){
            // if()
            this.inModeBtn = parseInt(res.RCStatus.ACMode);
            this.temp = parseInt(res.RCStatus.TargetACTemp);
            this.windSpeed = parseInt(res.RCStatus.EvaporatorFan);
            this.durationShow = res.RCStatus.ACRemainingTime ? res.RCStatus.ACRemainingTime : "00:00";
            this.duration[1] = parseInt(this.durationShow.split(":")[0]);
            // this.duration[0] = Math.floor(_ACRemainingTime/60);
            // this.duration[1] = _ACRemainingTime%60;
          }else{
            // this.inModeBtn = 1;
            // this.temp = 21;
            // this.windSpeed = 1;
            // this.duration[0] = 0;
            // this.duration[1] = 30;
          }
          if(this.isShowReply){
            if(res.RCResp.AC!=""){
              let contain = this.replyAnalysis("");
              if(contain == "") return;
              this.$message({
                message: this.$t('执行失败')+'，'+this.$t('失败原因')+'：' + contain,
                type: 'warning',
                showClose: true,
              });
              this.isShowReply = false;
            }
          }
        })
        .catch((e)=>{
          this.realLoading = false;
        })
      // }
    },
    async startTimer() {
      // console.log("开始定时");
      if (this.secondInterval) {
        clearInterval(this.secondInterval);
      }
       // 立即执行一次
      await this.queryReal();
      
      if(!this.configStatus) return;
      // 设置定时器，5000毫秒 = 5秒
      this.secondInterval = setInterval(() => {
        this.queryReal()
      }, 1000);
    },
    // 停止定时器
    stopTimer() {
      if (this.secondInterval) {
        clearInterval(this.secondInterval);
        this.secondInterval = null;
        // console.log("5秒定时器已停止");
      }
    },
    replyAnalysis(value){
      var replyType = 0;//1灯光控制,2喇叭控制,3闪灯鸣笛控制,4开启空调,5关闭空调，6其他参数控制
      if(goOnOrOff == "on"){
        // 要开启，提示的是开启空调失败内容
        replyType = 4;
      }else if(goOnOrOff == "off"){
        // 要关闭，提示的是关闭空调失败内容
        replyType = 5;
      }
      switch(replyType){
        case 4://4开启空调
          if(value == "401") return "空调处于本地模式不执行远控";
          if(value == "402") return "车辆发动机未启动";
          if(value == "403") return "后舱门开启";
          if(value == "404") return "手刹松开";
          if(value == "405") return "存在刹车信号";
          if(value == "406") return "非空档位和停车档位状态";
          if(value == "407") return "存在油门信号";
          if(value == "408") return "存在四级或以上故障";
          if(value == "409") return "油量小于 10%";
          if(value == "410") return "车速大于 2km/h";
          if(value == "411") return "蓄电池电压小于 23V";
          if(value == "412") return "电车 ACC 打开，钥匙不处于 OFF 档";
          if(value == "413") return "动力电池 soC>30%";
          if(value == "001") return "控制ID非法";
          if(value == "414") return "轻客整车ON电上电控制执行失败";
          if(value == "415") return "轻客BCM处于补电流程中，不执行此远控命令";
          if(value == "416") return "当前车辆有人员操作TBOX已退出远控";
          return "";
          break;
        case 5://5关闭空调
          if(value == "501") return "空调处于本地模式不执行远控";
          if(value == "001") return "控制ID非法";
          if(value == "502") return "轻客整车ON电下电控制执行失败";
          if(value == "503") return "轻客BCM处于补电流程中，不执行此远控命令";
          if(value == "504") return "当前车辆有人员操作TBOX已退出远控";
          return "";
          break;
      }
    }
  },
  watch:{
    inTypeBtn:{
      handler(newVal,oldVal){
        // if(newVal == 0 && oldVal !=0 ){
        //   // 从另外两个按钮预约切换回立即，查下当下实时状态
        //   // this.queryReal();
        //   this.vehicles = this.getSelectedVehicles();
        //   let isOr = this.judge();
        //   if(!isOr) {
        //     this.ACState = false;
        //   }else{
        //     this.inModeBtn = 1;
        //     this.temp = 21;
        //     this.windSpeed = 1;
        //     this.duration[0] = 0;
        //     this.duration[1] = 30;
        //     this.startTimer();
        //   }
        // }
        // if(newVal != 0 && oldVal == 0){
        //   // 从立即切换回预约，查询该车是否在预约范围中未失效
        //   this.queryBooking();
        //   this.stopTimer();
        // }
      }
    },
    selectedVehicles:{
      handler(newVal, oldVal) {
        if(this.tabs == "first"){
          if(newVal.length == 0) {
            this.ACState = false;
            this.haseBooking = false;
            this.stopTimer();
            return;
          };
          if(this.inTypeBtn == 0){
            // this.queryReal();
            this.vehicles = this.getSelectedVehicles();
            let isOr = this.judge();
            if(!isOr) {
              this.ACState = false;
              this.stopTimer();
            }else{
              this.inModeBtn = 1;
              this.temp = 21;
              this.windSpeed = 1;
              this.duration[0] = 0;
              this.duration[1] = 30;
              this.isFirst = true;
              this.startTimer();
            }
          }else{
            this.stopTimer();
            this.queryBooking();
          }
        }
      }
    },
    duration:{
      // 限制开启时长不能为00:00
      handler(newVal, oldVal) {
        if(this.minuteDisabled&&newVal[0]!=24){
          this.minuteDisabled = false;
        }
        if(newVal[0] == 24){
          this.duration[1] = 0;
          this.minuteDisabled = true;
        }
        if(newVal[0] == 0&&newVal[1] == 0){
          this.minute[0].disabled = true;
          if(newVal[1] == 0){
            this.duration[1] = 1;
          }
        }
        if(newVal[0] != 0){
          if(!this.minute[0].disabled) return;
          else this.minute[0].disabled = false;
        }
      },
      deep: true 
    }
  },
  computed:{
    ...mapState({
        selectedVehicles: state => state.app.vehicles.selectedVehicles,
    }),
    size() {
        return this.$store.getters.size
    },
    closeBtn(){
      // 是否有立即的关闭按钮
      if(this.inTypeBtn == 0) return true;
      return false;
    },
    closeBtnText(){
      if(!this.ACState) return this.$t('public.open');
      return this.$t('public.close');
    }
  },
  mounted(){
    const now = new Date();
    now.setTime(now.getTime() + 5 * 60 * 1000);
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const result = `${hours}:${minutes}`;

    this.rangeTime = result;
    this.dateRanDate = [now, now];
    this.computeLeft();
    this.modeBtns = [
      {
        value:1,
        label: this.$t('ACSetting.自动')
      },
      {
        value:3,
        label: this.$t('ACSetting.通风')
      },
      {
        value:4,
        label: this.$t('ACSetting.制冷')
      },
      {
        value:5,
        label: this.$t('ACSetting.制热')
      },
      
    ];
    this.typeBtns = [
      {
        value:0,
        label: this.$t('ACSetting.立即执行')
      },
      {
        value:1,
        label: this.$t('ACSetting.空调预约')
      },
      // {
      //   value:2,
      //   label:"周期预约"
      // },
    ];
    for(let i = 0;i<25;i++){
      this.hours.push(
        {
          value:i,
          label:i +' 小时'
        },
      )
    };
    for(let i = 0;i<31;i++){
      if(i == 0){
        this.minute.push(
          {
            value:i,
            label:i + this.$t('ACSetting.分钟'),
            disabled: true,
          },
        )
      }else{
        this.minute.push(
          {
            value:i,
            label:i + this.$t('ACSetting.分钟'),
            disabled: false,
          },
        )
      }
    }

    this.windSpeedOptions = [{value:1,label:"1 "+this.$t("ACSetting.档")},{value:2,label:"2 "+this.$t("ACSetting.档")},{value:3,label:"3 "+this.$t("ACSetting.档")},];

  },
  activated(){
    if(this.inTypeBtn == 0){
      this.vehicles = this.getSelectedVehicles();
      let isOr = this.judge();
      if(!isOr) {
        this.ACState = false;
      }else{
        this.startTimer();
      }
    }
  },
  destroyed() {
    this.stopTimer();
  },
  deactivated(){
    this.stopTimer();
  },
}
</script>
<style lang="scss" scoped>
.imgClick{
  height:24px;
  width:24px;
  cursor: pointer;
}
.slider{
  flex:1;
  margin: 0px 16px;
  position: relative;
  ::v-deep {
    .el-slider__runway{
      background-color: #fff !important;
    }
  }
}
.textTitle{
  font-weight: 400;
  font-size: 14px;
  color: #0E193B;
  margin-top: 20px;
}
.flex1{
  flex: 1;
  &::v-deep {
    .el-date-editor.el-input, .el-date-editor.el-input__inner {
      .el-input__inner {
          background-color: #ffffff00 !important;
          color: #0F1A3A;
          width: 240px;
      }
    }
    .el-date-editor--daterange.el-input, .el-date-editor--daterange.el-input__inner, .el-date-editor--timerange.el-input, .el-date-editor--timerange.el-input__inner{
      background-color: #ffffff00 !important;
      color: #0F1A3A;
      width: 240px;
    }
    .el-date-editor .el-range-input{
      background-color: transparent !important;
    }
  }
}

.inactive{
  margin-right:6px;
  background: #D9E4F8 !important;
  color: #2A7AFF !important;
}
.active{
  margin-right:6px;
  background: #2A7AFF !important;
  color: #fff !important;
}
.tmp{
  height:100px;
  width:500px;
  background: #dfeaff;
  border-radius: 2px;
  margin-top:10px;
  display: flex;
  align-items: center;
  padding: 0px 20px;
}
.tempText{
    position: absolute;
    z-index: 1;
    font-weight: 600;
    font-size: 16px;
    color: #2A7AFF;
    bottom:95%
}
.fanWidth{
  &::v-deep {
    .el-select {
      .el-input.el-input--suffix {
        // 2.修改背景颜色、字体颜色、边框、宽高
        .el-input__inner {
            width: 500px !important; 
        }
      }
    }
  }
}
.selectTime {
  margin-top: 10px;
  flex: 1;
  &::v-deep {
    .el-select {
      .el-input.el-input--suffix {
        // 2.修改背景颜色、字体颜色、边框、宽高
        .el-input__inner {
            background-color: #ffffff00 !important;
            color: #0F1A3A;
            height: 32px;
            width: 500x; 
            // width: 240px; 
        }
      }
          // 符号的位置会错乱，进行修正（垂直）
      .el-select__caret.el-input__icon.el-icon-arrow-up {
        line-height: 30px;
      }
    }
  }
}

.el-button--primary.is-plain{
    color: #2A7AFF;
    background: transparent;
    border-color: #2A7AFF;
}

._durationShow{
  width: 500px;
  display: flex;
  justify-content: space-between;
}

</style>